import React from "react";

const TableHeader = ({ columns, sortColumn, handleSort }) => {
  const raiseSort = (path) => {
    if (sortColumn.path === path) {
      sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
    } else {
      sortColumn.path = path;
      sortColumn.order = "asc";
    }
    if (handleSort) handleSort(sortColumn);
  };

  return (
    <thead>
      <tr>
        {columns &&
          columns.map(({ key, path, label }) => (
            <th key={key || path} onClick={() => raiseSort(path)}>
              {label}
            </th>
          ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
